import type { Editor } from '@tiptap/react'

import type { MarkdownEditorProps } from '../markdown-editor.interface'
import { useMarkdownEditor } from './useMarkdownEditor.hook'
import { useMarkdownEditorCharacterCount } from './useMarkdownEditorCharacterCount.hook'
import { useMarkdownEditorExtensions } from './useMarkdownEditorExtensions.hook'

export interface MarkdownEditorSetupResult {
  editor: Editor | null
  isMounted: boolean
  characterCount: number
}

/**
 * Combined hook that sets up all editor functionality
 */
export const useMarkdownEditorSetup = (props: MarkdownEditorProps): MarkdownEditorSetupResult => {
  const {
    initialValue = '',
    placeholder = 'Start typing...',
    variant = 'full',
    mentions = [],
    mentionTrigger = '@',
    readOnly = false,
    disabled = false,
    autoFocus = false,
    spellCheck = true,
    onChange,
    onBlur,
    onSubmit,
    onMentionSelect,
    onMentionSearch,
  } = props

  const extensions = useMarkdownEditorExtensions({
    placeholder,
    mentionList: mentions,
    mentionTrigger,
    onMentionSearch,
    onMentionSelect,
  })

  const { editor, isMounted } = useMarkdownEditor({
    extensions,
    initialValue,
    variant,
    isReadOnly: readOnly,
    isDisabled: disabled,
    isAutoFocus: autoFocus,
    isSpellCheck: spellCheck,
    onChange,
    onBlur,
    onSubmit,
  })

  const characterCount = useMarkdownEditorCharacterCount(editor)

  return { editor, isMounted, characterCount }
}
